// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetSequenceNumberListRequestViewModel from '../../viewModel/request/Sequencenumbers/GetSequenceNumberListRequestViewModel';
import SequenceNumberListResourcePagingResultViewModel from '../../viewModel/resource/SequenceNumberListResourcePagingResultViewModel';
import SequenceNumberCreateRequestViewModel from '../../viewModel/resource/SequenceNumberCreateRequestViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getSequenceNumberList(request: GetSequenceNumberListRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sequence-number-list'] ?? 'core/Sequencenumbers';
    const response = await service.get<any>(endpointPath, {
      query: {
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new SequenceNumberListResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async createSequenceNumber(model: SequenceNumberCreateRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-sequence-number'] ?? 'core/Sequencenumbers';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return result as number | undefined;
  },
  /**  */
  async updateSequenceNumber(id: number, nextNumber: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-sequence-number'] ?? 'core/Sequencenumbers/{id}/SetNextNumber/{nextNumber}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    endpointPath = endpointPath.replace(/\{nextNumber\}/g, `${nextNumber}`);
    const response = await service.put<any>(endpointPath, {
      ...config,
    });
  },
  /**  */
  async deleteSequenceNumber(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-sequence-number'] ?? 'core/Sequencenumbers/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
  },
});
